<div class="cnt">
    <div class="row-title">
        <teiasoft-title [title]="'itdcr.title' | translate"></teiasoft-title>
        <div style="display: flex; width: 100%; justify-content: flex-end; gap: 0.5rem;">
            <teiasoft-toolbar *ngIf="showBackButton" [buttonsList]="buttonsListBack" [theme]="globals.theme!"
                (onBtnClick)="onBtnToolbarClick($event)"></teiasoft-toolbar>
            <teiasoft-toolbar [buttonsList]="buttonsList" [theme]="globals.theme!" (onBtnClick)="onBtnToolbarClick($event)"
                style="flex: 1;"></teiasoft-toolbar>
        </div>
    </div>

    <as-split [style.display]="(showHistory || showLatestSent) ? 'none' : ''" direction="vertical" restrictMove="true"
        (dragEnd)="onSplitChanged($event)" (gutterDblClick)="onSplitChanged(event)">
        <as-split-area style="display: flex;flex-direction: column;" [size]="topSectionSize">
            <div class="area-header">
                <h4>{{'itdcr.active'| translate}}</h4>
            </div>
            <div class="area-table" #areaTopTable>
                <teiasoft-grid-odata #activeGrid [columnsToHideGOD]="columnsToHide"
                    [customIcoCols]="activeCustomIcoCols" [calculatedCols]="calculatedCols" [oDataUrl]="activeODataUrl"
                    [clearFilters]="clearFilters" [odataEntity]="activeODataEntity" [sortable]="true"
                    [theme]="globals.theme!" style="width:100%" [selectable]="false" [enableDoubleClick]="false"
                    [disableAllSelection]="false" [filterable]="gridFilterable" [dateFormat]="globals.dateFormat!"
                    [dateTimeFormat]="globals.dateTimeFormat!" [dateOnlyColumns]="dateOnlyColumns" [autoWidth]="true"
                    [showSettingsDialog]="showSettingsDialog" (onCloseDialogSettings)="showSettingsDialog = false"
                    [gridConfiguration]="gridConfiguration" (onGetOdataEntity)="onGetOdataEntity($event)"
                    [paginable]="true" [rowsPerPage]="100" [enableStickyColumnsAtStart]="true"
                    [refreshGridKey]="refreshGridKey" (customIconClick)="customIconClick($event)"
                    [maxHeightVh]="activeBodyVh" (onUpdateConfiguration)="onUpdateConfiguration($event)"
                    [headerParametersValues]="headerParametersValues" [roundDigits]="roundDigitsForGrid"
                    [initialFilters]="activeInitialFilters" (onActiveFiltersUpdate)="onActiveFiltersUpdate($event)"
                    (onCellClick)="onCellClick($event)">
                </teiasoft-grid-odata>
            </div>
        </as-split-area>
        <as-split-area [size]="bottomSectionSize">
            <div class="area-header">
                <h4>{{'itdcr.toCome'| translate}}</h4>
            </div>
            <div class="area-table" #areaBottomTable>
                <teiasoft-grid-odata #toComeGrid [columnsToHideGOD]="columnsToHide"
                    [customIcoCols]="toComeCustomIcoCols" [calculatedCols]="calculatedCols" [oDataUrl]="toComeODataUrl"
                    [clearFilters]="clearFilters" [odataEntity]="toComeODataEntity" [sortable]="true"
                    [theme]="globals.theme!" style="width:100%" [selectable]="false" [enableDoubleClick]="true"
                    [disableAllSelection]="false" [filterable]="gridFilterable" [dateFormat]="globals.dateFormat!"
                    [dateTimeFormat]="globals.dateTimeFormat!" [dateOnlyColumns]="dateOnlyColumns" [autoWidth]="true"
                    [showSettingsDialog]="showSettingsDialog" (onCloseDialogSettings)="showSettingsDialog = false"
                    [gridConfiguration]="gridConfiguration" (onGetOdataEntity)="onGetOdataEntity($event)"
                    [paginable]="true" [rowsPerPage]="100" [enableStickyColumnsAtStart]="true"
                    [refreshGridKey]="refreshGridKey" (customIconClick)="customIconClick($event)"
                    [maxHeightVh]="toComeBodyVh" (onUpdateConfiguration)="onUpdateConfiguration($event)"
                    [headerParametersValues]="headerParametersValues" [roundDigits]="roundDigitsForGrid"
                    [initialFilters]="toComeInitialFilters" (onActiveFiltersUpdate)="onActiveFiltersUpdate($event)"
                    (onCellClick)="onCellClick($event)">
                </teiasoft-grid-odata>
            </div>
        </as-split-area>
    </as-split>
    <div *ngIf="showLatestSent" style="width: 100%;">
        <teiasoft-grid-odata #activeGrid [columnsToHideGOD]="columnsToHideHistory"
            [customIcoCols]="latestSentCustomIcoCols" [calculatedCols]="calculatedCols" [oDataUrl]="latestSentODataUrl"
            [odataEntity]="latestSentODataEntity" [sortable]="true" [theme]="globals.theme!" style="width:100%"
            [selectable]="false" [enableDoubleClick]="false" [disableAllSelection]="false" [filterable]="gridFilterable"
            [dateFormat]="globals.dateFormat!" [dateTimeFormat]="globals.dateTimeFormat!"
            [dateOnlyColumns]="dateOnlyColumns" [autoWidth]="true"
            [showSettingsDialog]="showSettingsDialog" (onCloseDialogSettings)="showSettingsDialog = false"
            [gridConfiguration]="latestSentGridConfiguration" (onGetOdataEntity)="onGetOdataEntity($event)"
            [paginable]="true" [rowsPerPage]="100" [enableStickyColumnsAtStart]="true" [refreshGridKey]="refreshGridKey"
            (customIconClick)="customIconClick($event)" (onUpdateConfiguration)="onUpdateLatestSentConfiguration($event)"
            [initialFilters]="latestSentInitialFilters" [headerParametersValues]="headerParametersValues"
            [roundDigits]="roundDigitsForGrid" [clearFilters]="clearFilters"
            (onActiveFiltersUpdate)="onActiveFiltersUpdate($event)" (onCellClick)="onCellClick($event)">
        </teiasoft-grid-odata>
    </div>
    <div *ngIf="showHistory" style="width: 100%;">
        <teiasoft-grid-odata #activeGrid [columnsToHideGOD]="columnsToHideHistory"
            [customIcoCols]="historyCustomIcoCols" [calculatedCols]="calculatedCols" [oDataUrl]="historyODataUrl"
            [odataEntity]="historyODataEntity" [sortable]="true" [theme]="globals.theme!" style="width:100%"
            [selectable]="false" [enableDoubleClick]="false" [disableAllSelection]="false" [filterable]="gridFilterable"
            [dateFormat]="globals.dateFormat!" [dateTimeFormat]="globals.dateTimeFormat!"
            [dateOnlyColumns]="dateOnlyColumns" [autoWidth]="true"
            [showSettingsDialog]="showSettingsDialog" (onCloseDialogSettings)="showSettingsDialog = false"
            [gridConfiguration]="historyGridConfiguration" (onGetOdataEntity)="onGetOdataEntity($event)"
            [paginable]="true" [rowsPerPage]="100" [enableStickyColumnsAtStart]="true" [refreshGridKey]="refreshGridKey"
            (customIconClick)="customIconClick($event)" (onUpdateConfiguration)="onUpdateHistoryConfiguration($event)"
            [initialFilters]="historyInitialFilters" [showFiltersOnLoad]="historyInitialFilters.length > 0"
            [headerParametersValues]="headerParametersValues" [roundDigits]="roundDigitsForGrid"
            [clearFilters]="clearFilters" (onActiveFiltersUpdate)="onActiveFiltersUpdate($event)"
            (onCellClick)="onCellClick($event)">
        </teiasoft-grid-odata>
    </div>



</div>

<!-- CONFIRM  MODAL -->
<teiasoft-modal (onConfirmClick)="onConfirmModal($event)" [theme]="globals.theme!"
    [isMobile]="!globals.isDesktop!" [scope]="'itdcr'"></teiasoft-modal>

<!-- SEND  MODAL -->
<app-modal-send-itdcr [itdcrNo]="selectedItdcrNo" *ngIf="showSendItdcr" [isMobile]="!globals.isDesktop!"
    [millMode]="millMode" (onClose)="showSendItdcr = false" (onSave)="onSendItdcr()" />

<!-- ATTACHMENTS  MODAL -->
<app-modal-itdcr-attachments *ngIf="showAttachments" [itdcrNo]="selectedItdcrNo" (onClose)="onCloseAttachments()"
    [readOnly]="isReadOnlyMode"></app-modal-itdcr-attachments>

<!-- TEMPORARY NOTES  MODAL -->
<app-modal-itdcr-notes *ngIf="showTempNotes" [itdcrNo]="selectedItdcrNo" [itdcrNotes]="selectedItdcrNotes"
    [readOnly]="isReadOnlyMode" (onClose)="showTempNotes = false" (onSave)="onSaveNotes($event)"></app-modal-itdcr-notes>

<!-- VISUAL OVERVIEW  MODAL -->
<app-modal-itdcr-visual-overview *ngIf="showVisualOverview" [itdcrNo]="selectedItdcrNo"
    (onClose)="showVisualOverview = false"></app-modal-itdcr-visual-overview>

<!-- SPECIAL REQUIREMENTS MODAL -->
<app-modal-special-requirements *ngIf="showSpecialRequirements" [readOnly]="true"
    [initialCustomerSpecialRequirements]="customerSpecialRequirements"
    (onClose)="showSpecialRequirements = false"></app-modal-special-requirements>
